export { TypographyGenerator } from './TypographyGenerator';
